import React, { useEffect, useState } from "react";
import t from "../../../helpers/t";
import { rbac } from "../index";
import { useSelector, resourcesActions } from "inbooma-api";
import { Biscuit } from "../../../../utils";

const ResourceAddition = (props) => {
  const { resources, contingent, dispatch } = props;
  const _resource = useSelector((state) => state["resources_data"].patchResource);
  const [localResources, setLocalResources] = useState(resources);
  const [resourcePending, setResourcePending] = useState(null);
  useEffect(() => {
    if (resourcePending === null || _resource.success === "") return;
    setResourcePending(null);
  }, [_resource]);
  const getStatusSelect = (resource) => {
    let status = resource.status;
    return [
      {
        text: t("active", null, "capital"),
        value: "active",
        disabled: "",
        selected: status === "active",
      },
      {
        text: t("inactive", null, "capital"),
        value: "inactive",
        disabled: "",
        selected: status === "inactive",
      },
      {
        text: t("defect", null, "capital"),
        value: "defect",
        disabled: "",
        selected: status === "defect",
      },
    ];
  };

  const setStatus = (e, resource, index) => {
    let clone = localResources;
    // Object.assign(clone,localResources);
    resources[index].status = e.target.value;
    //setLocalResources(clone);
    dispatch(
      resourcesActions.patchResource({
        token: Biscuit.get("token"),
        resource_id: resource.id,
        data: {
          status: e.target.value,
        },
      }),
    );
    setResourcePending(index);
  };
  return (
    <>
      <header className="inb-c-item-details__header small-12 column">
        <a
          href={"resources/add?path=/contingents&item=" + contingent.id}
          className="inb-c-item-add inb-resource-manage small button beautify float-right"
          data-inb-contingent-id={contingent.id}
          data-inb-action-link="write"
        >
          {" "}
          {t("add_${a}", { a: t("resource") })}{" "}
        </a>
        {typeof resources !== "undefined" && resources.length === 0 && (
          <span className="inb-list-title">{t("no_linked_resources")}</span>
        )}
        {typeof resources !== "undefined" && (
          <span className="inb-list-title">{t("linked_resources") + " " + resources.length}</span>
        )}
      </header>
      {resources.map((resource, index) => {
        return (
          <>
            <div
              className="inb-resource inb-c-item-details-row row"
              data-inb-resource-id={resource.id}
              data-inb-context="resources"
            >
              <div className="column large-3 medium-7 small-6">
                <div className="row">
                  <div
                    className="large-3 medium-12 small-12 column inb-resource__id show-label"
                    title="ID"
                  >
                    #{resource.id}
                  </div>
                  <div
                    className="large-9 medium-12 small-12 column inb-resource__name show-label"
                    title={t("name", null, "capital")}
                  >
                    {resource.name}
                    {resource.name === "" && (resource.mac === "" || resource.mac == null) && (
                      <i>{t("resource_not_configured_yet")}</i>
                    )}
                  </div>
                </div>
              </div>

              <div
                className="large-1 medium-12 hide-for-small-only column inb-resource__resource_nbr show-label"
                title={t("external_resource_id_short")}
              >
                {resource.resource_nbr}
              </div>

              {resource.latitude !== "" &&
              resource.latitude !== null &&
              resource.longitude !== "" &&
              resource.longitude !== null ? (
                <>
                  <div
                    className="large-1 medium-12 column inb-resource__location show-label"
                    title={t("location", null, "capital")}
                    style={{ textAlign: "center" }}
                  >
                    <a
                      href={
                        "https://www.google.com/maps/search/?api=1&query=" +
                        resource.latitude +
                        "," +
                        resource.longitude
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      title={t("open_external_link")}
                    >
                      <i className="fi fi-map"></i>
                    </a>
                  </div>
                </>
              ) : (
                <>
                  <div className="medium-1 column hide-for-small-only"></div>
                </>
              )}
              {resource.battery_value !== "" && resource.battery_value !== null ? (
                <>
                  <div
                    className="large-1 medium-12 column inb-resource__battery show-label"
                    title={t("battery_condition") + " : " + resource.battery_value + "%"}
                  >
                    {resource.battery_value >= 50 && (
                      <>
                        <i className="fi fi-battery-full battery--full"></i>
                        <span>{resource.battery_value}%</span>
                      </>
                    )}
                    {resource.battery_value < 50 && resource.battery_value > 25 && (
                      <>
                        <i className="fi fi-battery-half battery--half"></i>
                        <span>{resource.battery_value}%</span>
                      </>
                    )}
                    {resource.battery_value <= 25 && (
                      <>
                        <i className="fi fi-battery-empty battery--empty"></i>
                        <span className="battery--empty">{resource.battery_value}%</span>
                      </>
                    )}
                  </div>
                </>
              ) : (
                <div className="medium-1 column hide-for-small-only"></div>
              )}
              <div
                className="large-3 medium-12 hide-for-small-only column inb-resource__mac show-label"
                title={t("mac_adress")}
              >
                {resource.mac}
              </div>

              <div
                className="large-1 medium-12 small-4 medium-offset-0 column"
                title={t("status", null, "capital")}
                style={{ padding: 0 }}
              >
                <div className="inb-status-select small" data-inb-status={resource.status}>
                  {resourcePending !== index ? (
                    <>
                      {rbac.hasPermission("configureResource") ? (
                        <select
                          name="resourceStatus"
                          data-inb-action-link="edit-status"
                          defaultValue={resource.status}
                          onChange={(e) => setStatus(e, resource, index)}
                        >
                          {getStatusSelect(resource).map((obj) => {
                            return (
                              <>
                                <option value={obj.value} disabled={obj.disabled}>
                                  {obj.text}
                                </option>
                              </>
                            );
                          })}
                        </select>
                      ) : (
                        <span>{resource.status}</span>
                      )}
                    </>
                  ) : (
                    <>
                      {" "}
                      <span>
                        <img
                          alt="RollingLoader"
                          className="rollingLoader colorize-black"
                          src={"assets/img/rolling_loader.svg"}
                        />{" "}
                      </span>
                    </>
                  )}
                </div>
              </div>

              <div className="large-2 medium-12 small-2 column text-right">
                <div className="row">
                  <div className="medium-8 small-6 column text-right">
                    <a
                      className="inb-resource__edit inb-c-item__edit"
                      href={"resources/" + resource.id + "?path=/contingents&item=" + contingent.id}
                      data-inb-action-link="edit"
                    >
                      <i className="fi fi-wrench"></i>
                    </a>
                  </div>
                  <div className="medium-4 small-6 column text-left">
                    <a
                      className="inb-resource__remove inb-c-item__remove"
                      href="#"
                      data-inb-action-link="remove"
                      title={t("delete_${a}", { a: t("resource") })}
                    >
                      <i className="fi fi-trash"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      })}
    </>
  );
};
export default ResourceAddition;
